// extracted by mini-css-extract-plugin
export default {"AppHero":"AppHeroFigure_AppHero__kVhbm","AppHero__figure":"AppHeroFigure_AppHero__figure__PuiBb"};